import yotaMarquee from './_yotaMarquee'

export function marquee() {
  yotaMarquee.init({
    selector: '.js-marquee',
  })
}
